import { Component, OnInit } from '@angular/core';
import { AccountService } from '@core/services/account.service';
import { Country } from '@shared/models';
import { combineLatest, Observable } from 'rxjs';
import { MemberFirmService } from '@core/services/member-firm.service';
import { MemberFirm } from '@shared/models/member-firm.model';
import { take } from 'rxjs/operators';

@Component({
  selector: 'gcc-country-dropdown',
  templateUrl: './country-dropdown.component.html',
  styleUrls: ['./country-dropdown.component.scss']
})
export class CountryDropdownComponent implements OnInit {
  public countries$: Observable<Country[]> = this.accountService.availableCountries$;
  public country$: Observable<string> = this.accountService.countryCode$;
  public memberFirms$: Observable<MemberFirm[]> = this.memberFirmService.memberFirms$;

  constructor(private accountService: AccountService, private memberFirmService: MemberFirmService) {}

  public handleSelectCountry(memberFirm: MemberFirm) {
    this.accountService.setCountry(memberFirm.countryCode);
    this.memberFirmService.selectedMemberFirmId = memberFirm.id;
  }

  public ngOnInit(): void {
    combineLatest(this.country$, this.memberFirms$)
      .pipe(take(1))
      .subscribe(([selectedCountry, memberFirms]) => {
        this.memberFirmService.selectedMemberFirmId = memberFirms.find(
          memberFirm => memberFirm.countryCode === selectedCountry
        ).id;
      });
  }
}
